import { faTextSize as faTextSizeLight } from '@fortawesome/pro-light-svg-icons';
import { faGears, faTextSize } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { UpdateFormatsSettingsForm } from '~/components/forms/FormatsSettingsForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';

export type IAppFormatsSettingsPageProps = {
  appId: string;
  nextUrl?: string;
  cancelUrl?: string;
};

export const AppFormatsSettingsPage: React.FC<IAppFormatsSettingsPageProps> = (
  props,
) => {
  const { appId, nextUrl, cancelUrl } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const parentUrl = `/apps/${appId}/settings`;

  return (
    <>
      <Helmet>
        <title>{t('AppFormatsSettingsPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faGears} />
          {t('common.settings')}
        </Breadcrumbs.Action>
        <Breadcrumbs.Text current>
          <FontAwesomeIcon icon={faTextSize} />
          {t('AppFormatsSettingsPage.title')}
        </Breadcrumbs.Text>
      </AppBreadcrumbs>

      <Heading
        icon={<FontAwesomeIcon icon={faTextSizeLight} />}
        title={t('AppFormatsSettingsPage.title')}
        subtitle={t('AppFormatsSettingsPage.subtitle')}
        previousUrl={parentUrl}
      />

      <UpdateFormatsSettingsForm
        appId={appId}
        onSuccess={nextUrl ? () => navigate(nextUrl) : undefined}
        cancelUrl={cancelUrl ?? parentUrl}
      />
    </>
  );
};
